(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3311],{

/***/ 5503:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ImageWithFallback; }
/* harmony export */ });
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35944);



function ImageWithFallback(_ref) {
  var src = _ref.src,
      _ref$alt = _ref.alt,
      alt = _ref$alt === void 0 ? "" : _ref$alt,
      className = _ref.className,
      _ref$fallback = _ref.fallback;
  _ref$fallback = _ref$fallback === void 0 ? {} : _ref$fallback;
  var _ref$fallback$size = _ref$fallback.size,
      size = _ref$fallback$size === void 0 ? "640x16:9" : _ref$fallback$size,
      _ref$fallback$bg = _ref$fallback.bg,
      bg = _ref$fallback$bg === void 0 ? "eeeeee" : _ref$fallback$bg,
      _ref$fallback$color = _ref$fallback.color,
      color = _ref$fallback$color === void 0 ? "333333" : _ref$fallback$color,
      _ref$fallback$text = _ref$fallback.text,
      text = _ref$fallback$text === void 0 ? alt || "DaMaWish" : _ref$fallback$text,
      fallbackSrc = _ref$fallback.src;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(!src),
      error = _useState[0],
      setError = _useState[1];

  fallbackSrc = fallbackSrc || "https://dummyimage.com/".concat(size, "/").concat(bg, "/").concat(color, "&text=").concat(encodeURIComponent(text));
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)((next_image__WEBPACK_IMPORTED_MODULE_0___default()), {
    src: error ? fallbackSrc : src,
    layout: 'fill',
    alt: alt,
    className: className,
    onError: function onError() {
      return setError(true);
    }
  });
}

/***/ }),

/***/ 4656:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Rating; }
/* harmony export */ });
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4730);
/* harmony import */ var _fortawesome_pro_solid_svg_icons_faStar__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(84887);
/* harmony import */ var _fortawesome_pro_regular_svg_icons_faStar__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(62361);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67814);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44612);
/* harmony import */ var tailwind_merge__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(57851);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);




var _excluded = ["className"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





function Rating(_ref) {
  var className = _ref.className,
      props = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref, _excluded);

  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, _objectSpread({
    icon: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__/* .FontAwesomeIcon */ .G, {
      icon: _fortawesome_pro_solid_svg_icons_faStar__WEBPACK_IMPORTED_MODULE_5__/* .faStar */ .T
    }),
    emptyIcon: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__/* .FontAwesomeIcon */ .G, {
      icon: _fortawesome_pro_regular_svg_icons_faStar__WEBPACK_IMPORTED_MODULE_6__/* .faStar */ .T
    }),
    className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_7__/* .twMerge */ .m)('text-primary text-sm shrink-0', className)
  }, props));
}

/***/ }),

/***/ 28655:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ CategorySlug; }
/* harmony export */ });
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(50029);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var components_blocks_Wrapper__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(80819);
/* harmony import */ var components_blocks_Container__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(75046);
/* harmony import */ var layouts_Default__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87607);
/* harmony import */ var components_views_ProductListing__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56493);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41248);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57731);
/* harmony import */ var lib_features_brandSlice__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(77078);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(35944);











var __N_SSP = true;
function CategorySlug(props) {
  var categorySlug = props.categorySlug,
      _page = props.page,
      _filter = props.filter,
      _sort = props.sort,
      deals = props.allDeals;

  var _useTranslation = (0,next_i18next__WEBPACK_IMPORTED_MODULE_5__/* .useTranslation */ .$G)(),
      t = _useTranslation.t;

  var products = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function (state) {
    return state.product.products;
  }, react_redux__WEBPACK_IMPORTED_MODULE_4__/* .shallowEqual */ .wU);
  var brands = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function (state) {
    return state.brand.brands;
  }, react_redux__WEBPACK_IMPORTED_MODULE_4__/* .shallowEqual */ .wU);

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(_filter),
      localFilter = _useState[0],
      setLocalFilter = _useState[1];

  var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useDispatch */ .I0)();

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false),
      loaded = _useState2[0],
      setLoaded = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(brands),
      localBrands = _useState3[0],
      setLocalBrands = _useState3[1];

  function initBrand() {
    return _initBrand.apply(this, arguments);
  }

  function _initBrand() {
    _initBrand = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)( /*#__PURE__*/_vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
      return _vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return dispatch((0,lib_features_brandSlice__WEBPACK_IMPORTED_MODULE_6__/* .getPaginatedBrandsThunk */ .XZ)({
                _page: _page,
                _filter: _filter,
                _sort: _sort
              }));

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _initBrand.apply(this, arguments);
  }

  var reInitFilter = function reInitFilter() {
    var tempFilter = localFilter;
    tempFilter.categories = [];
    tempFilter.categories.push(categorySlug);
    setLocalFilter(tempFilter);
  };

  (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function () {
    reInitFilter();
  }, [_filter]);
  (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function () {
    if (brands[0].name === 'Test') {
      initBrand();
    } else {
      setLoaded(true);
      setLocalBrands(brands.slice(brands.length - 5, brands.length));
    }

    return function () {
      console.log('clean up initBrand');
    };
  }, [brands]);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(components_blocks_Wrapper__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
    children: loaded ? (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(components_blocks_Container__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(components_views_ProductListing__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        _filter: localFilter,
        _page: _page,
        _sort: _sort,
        products: products,
        deals: [],
        brands: localBrands,
        baseUrl: "/products/".concat(categorySlug),
        type: 'Product',
        category: categorySlug
      })
    }) : (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(components_blocks_Container__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
      style: {
        marginTop: 50
      },
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("span", {
        children: t('home:loading')
      })
    })
  });
}

CategorySlug.getLayout = function getLayout(page) {
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(layouts_Default__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
    children: page
  });
};

/***/ }),

/***/ 59311:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/[categorySlug]",
      function () {
        return __webpack_require__(28655);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7948,3714,4909,2531,6393,7607,6493,9774,2888,179], function() { return __webpack_exec__(59311); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);